// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Bend} from './bend.js'
import {Color} from './color.js'
import {ConnectorCap} from './connector-cap.js'
import {ConnectorEndpoint, unionListToConnectorEndpoint, unionToConnectorEndpoint} from './connector-endpoint.js'
import {ConnectorPathStyle} from './connector-path-style.js'
import {InkStyle} from './ink-style.js'
import {InkTool} from './ink-tool.js'

export class CreateConnector {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): CreateConnector {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsCreateConnector(bb: flatbuffers.ByteBuffer, obj?: CreateConnector): CreateConnector {
    return (obj || new CreateConnector()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsCreateConnector(bb: flatbuffers.ByteBuffer, obj?: CreateConnector): CreateConnector {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new CreateConnector()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  startType(): ConnectorEndpoint {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ConnectorEndpoint.NONE
  }

  start<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null
  }

  endType(): ConnectorEndpoint {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ConnectorEndpoint.NONE
  }

  end<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null
  }

  pathStyle(): ConnectorPathStyle {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : ConnectorPathStyle.Orthogonal
  }

  bends(index: number, obj?: Bend): Bend | null {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? (obj || new Bend()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 8, this.bb!) : null
  }

  bendsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  startCap(): ConnectorCap {
    const offset = this.bb!.__offset(this.bb_pos, 16)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : ConnectorCap.None
  }

  endCap(): ConnectorCap {
    const offset = this.bb!.__offset(this.bb_pos, 18)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : ConnectorCap.FilledTriangle
  }

  tool(): InkTool {
    const offset = this.bb!.__offset(this.bb_pos, 20)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : InkTool.Pen
  }

  style(): InkStyle {
    const offset = this.bb!.__offset(this.bb_pos, 22)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : InkStyle.FixedWidth
  }

  color(obj?: Color): Color | null {
    const offset = this.bb!.__offset(this.bb_pos, 24)
    return offset ? (obj || new Color()).__init(this.bb_pos + offset, this.bb!) : null
  }

  borderWidth(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26)
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 4.0
  }

  zIndex(): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 28)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : null
  }

  positionLocked(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 30)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false
  }

  labelPosition(): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 32)
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : null
  }

  static startCreateConnector(builder: flatbuffers.Builder) {
    builder.startObject(15)
  }

  static addStartType(builder: flatbuffers.Builder, startType: ConnectorEndpoint) {
    builder.addFieldInt8(0, startType, ConnectorEndpoint.NONE)
  }

  static addStart(builder: flatbuffers.Builder, startOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, startOffset, 0)
  }

  static addEndType(builder: flatbuffers.Builder, endType: ConnectorEndpoint) {
    builder.addFieldInt8(2, endType, ConnectorEndpoint.NONE)
  }

  static addEnd(builder: flatbuffers.Builder, endOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, endOffset, 0)
  }

  static addPathStyle(builder: flatbuffers.Builder, pathStyle: ConnectorPathStyle) {
    builder.addFieldInt8(4, pathStyle, ConnectorPathStyle.Orthogonal)
  }

  static addBends(builder: flatbuffers.Builder, bendsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, bendsOffset, 0)
  }

  static startBendsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 4)
  }

  static addStartCap(builder: flatbuffers.Builder, startCap: ConnectorCap) {
    builder.addFieldInt8(6, startCap, ConnectorCap.None)
  }

  static addEndCap(builder: flatbuffers.Builder, endCap: ConnectorCap) {
    builder.addFieldInt8(7, endCap, ConnectorCap.FilledTriangle)
  }

  static addTool(builder: flatbuffers.Builder, tool: InkTool) {
    builder.addFieldInt8(8, tool, InkTool.Pen)
  }

  static addStyle(builder: flatbuffers.Builder, style: InkStyle) {
    builder.addFieldInt8(9, style, InkStyle.FixedWidth)
  }

  static addColor(builder: flatbuffers.Builder, colorOffset: flatbuffers.Offset) {
    builder.addFieldStruct(10, colorOffset, 0)
  }

  static addBorderWidth(builder: flatbuffers.Builder, borderWidth: number) {
    builder.addFieldFloat32(11, borderWidth, 4.0)
  }

  static addZIndex(builder: flatbuffers.Builder, zIndex: bigint) {
    builder.addFieldInt64(12, zIndex, null)
  }

  static addPositionLocked(builder: flatbuffers.Builder, positionLocked: boolean) {
    builder.addFieldInt8(13, +positionLocked, +false)
  }

  static addLabelPosition(builder: flatbuffers.Builder, labelPosition: number) {
    builder.addFieldFloat32(14, labelPosition, null)
  }

  static endCreateConnector(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 6) // start
    builder.requiredField(offset, 10) // end
    builder.requiredField(offset, 24) // color
    return offset
  }
}
